<template>
  <div id="grid-documento">
    <v-layout justify-center>
      <v-flex lg12>
        <v-spacer></v-spacer>
        <v-data-table
          :headers="headers"
          :items="itemsDocumento"
          :rows-per-page-items="rowsTable"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr class="tabla">
              <td>{{ props.item.subitem.nivel }}</td>
              <td class="text-xs-left">
                {{ props.item.subitem.tipoDocumento }}
              </td>
              <td class="text-xs-left">{{ props.item.estadoValidacion }}</td>
              <td class="text-xs-left">{{ props.item.fecha }}</td>
              <div class="text-xs-center">
                <td>
                  <!-- <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                title="Ver documento"
                @click="viewDocument(props.item.subitem.id)"
              >
                <v-icon>remove_red_eye</v-icon>
                    </v-btn>-->
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Editar documento"
                    @click="
                      editDocument(
                        props.item.subitem.id,
                        props.item.estadoValidacion
                      )
                    "
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                </td>
              </div>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!-- LEYENDA DE TABLA -->
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn
        class="btn-sigas"
        depressed
        outline
        icon
        fab
        dark
        color="primary"
        small
      >
        <v-icon>open_in_new</v-icon> </v-btn
      >Editar documento
    </v-card-actions>
    <!-- dialogo    -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Esta seguro?</v-card-title>
        <v-card-text
          >Esta seguro que desea realizar esta accion blaa blaa
          blaa.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="dialog = false"
            >Cancelar</v-btn
          >
          <v-btn color="green darken-1" flat @click="dialog = false"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialogo -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "grid-documento",
  components: {},
  props: {
    itemsDocumento: {},
    rowsTable: "",
  },
  data() {
    return {
      loading: false,
      dialog: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Nivel",
          align: "left",
          sortable: false,
          value: "nivel",
        },
        { text: "Tipo de Documento", sortable: false, value: "tipoDocumento" },
        { text: "Estado", sortable: false, value: "estado" },
        {
          text: "Fecha Ult. Actualizacion",
          sortable: false,
          value: "fechaActualizacion",
        },
        {
          text: "Accion",
          sortable: false,
          value: "",
        },
      ],
      listaDocumentos: [],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    editDocument(id, est) {
      this.$store.commit("view_validaciones_state", "modifica");
      this.$store.commit("validaciones_state", id);
      this.idDocumentoValidacion = this.$store.getters.idDocumentoValidacion;
      this.viewDocumento = this.$store.getters.viewValidaciones;
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ValidacionRegistra",
          params: {
            documentoId: this.idDocumentoValidacion,
            tipeView: this.viewDocumento,
            estadoValidacion: est,
          },
        });
      }, 1000);
    },
    viewDocument(id) {
      this.$store.commit("view_validaciones_state", "consulta");
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ValidacionRegistra",
          params: { documentoId: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    newDocument(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ValidacionRegistra",
          params: { tipeView: "consulta" },
        });
      }, 1000);
    },
  },
};
</script>
